import * as moment from "moment/moment";

export interface IResultInvitations {
  access: boolean;
  invitation: IInvitation;
}

export class ResultInvitations {
  access: boolean;
  invitation: Invitation;

  constructor(result?: IResultInvitations) {
    if (result) {
      this.access = result.access;
      this.invitation = new Invitation(result.invitation);
    } else {
      this.access = false;
      this.invitation = new Invitation();
    }
  }

  static fromObject(result: IResultInvitations): ResultInvitations {
    return new ResultInvitations(result);
  }
}

export interface IInvitation {
  id: number;
  request_number: string;
  role: IRole;
  role_id: number;
  email: string;
  first_name: string;
  last_name: string;
  delivered_email: boolean;
  phone_number: string;
  npi: string;
  request_type: string;
  requesting_user: IRequestingUser;
  requesting_user_id: number;
  user?: IUser | null;
  user_id?: number | null;
  status: string;
  created: moment.Moment;
  modified: moment.Moment;
  practice_names: string[];
}

export class Invitation {
  id: number;
  requestNumber: string;
  role: Role;
  roleId: number;
  email: string;
  firstName: string;
  lastName: string;
  deliveredEmail: boolean;
  phoneNumber: string;
  npi: string;
  requestType: string;
  requestingUser: RequestingUser;
  requestingUserId: number;
  user?: User | null;
  userId?: number | null;
  status: string;
  created: moment.Moment;
  modified: moment.Moment;
  practiceNames: string[];

  constructor(ent?: IInvitation) {
    if (ent) {
      this.id = ent.id;
      this.requestNumber = ent.request_number;
      this.role = new Role(ent.role);
      this.roleId = ent.role_id;
      this.email = ent.email;
      this.firstName = ent.first_name;
      this.lastName = ent.last_name;
      this.deliveredEmail = ent.delivered_email;
      this.phoneNumber = ent.phone_number;
      this.npi = ent.npi;
      this.requestType = ent.request_type;
      this.requestingUser = new RequestingUser(ent.requesting_user);
      this.requestingUserId = ent.requesting_user_id;
      this.user = ent.user ? new User(ent.user) : null;
      this.userId = ent.user_id;
      this.status = ent.status;
      this.created = moment(ent.created);
      this.modified = moment(ent.modified);
      this.practiceNames = ent.practice_names;
    }
  }

  static fromObject(ent: IInvitation): Invitation {
    return new Invitation(ent);
  }

  static fromObjectArray(ent: IInvitation[]): Invitation[] {
    return ent.map(item => new Invitation(item));
  }
}

export interface IRole {
  id: number;
  name: string;
  code: string;
  verification_required: boolean;
  description: string;
  role_type: string;
  practice_required: boolean;
  created: moment.Moment;
  modified: moment.Moment;
}

export class Role {
  id: number;
  name: string;
  code: string;
  verificationRequired: boolean;
  description: string;
  roleType: string;
  practiceRequired: boolean;
  created: moment.Moment;
  modified: moment.Moment;

  constructor(ent?: IRole) {
    if (ent) {
      this.id = ent.id;
      this.name = ent.name;
      this.code = ent.code;
      this.verificationRequired = ent.verification_required;
      this.description = ent.description;
      this.roleType = ent.role_type;
      this.practiceRequired = ent.practice_required;
      this.created = moment(ent.created);
      this.modified = moment(ent.modified);
    }
  }

  static fromObject(ent: IRole): Role {
    return new Role(ent);
  }
}

export interface IRequestingUser {
  id: number;
  username: string;
  first_name: string;
  last_name: string;
  email: string;
  is_active: boolean;
  is_staff: boolean;
  last_login: moment.Moment;
  date_joined: moment.Moment;
  is_superuser: boolean;
  is_verified: boolean;
}

export class RequestingUser {
  id: number;
  username: string;
  firstName: string;
  lastName: string;
  email: string;
  isActive: boolean;
  isStaff: boolean;
  lastLogin: moment.Moment;
  dateJoined: moment.Moment;
  isSuperuser: boolean;
  isVerified: boolean;

  constructor(ent?: IRequestingUser) {
    if (ent) {
      this.id = ent.id;
      this.username = ent.username;
      this.firstName = ent.first_name;
      this.lastName = ent.last_name;
      this.email = ent.email;
      this.isActive = ent.is_active;
      this.isStaff = ent.is_staff;
      this.lastLogin = moment(ent.last_login);
      this.dateJoined = moment(ent.date_joined);
      this.isSuperuser = ent.is_superuser;
      this.isVerified = ent.is_verified;
    }
  }

  static fromObject(ent: IRequestingUser): RequestingUser {
    return new RequestingUser(ent);
  }
}

export interface IUser {
  id: number;
  username: string;
  email: string;
  is_active: boolean;
}

export class User {
  id: number;
  username: string;
  email: string;
  isActive: boolean;

  constructor(ent?: IUser) {
    if (ent) {
      this.id = ent.id;
      this.username = ent.username;
      this.email = ent.email;
      this.isActive = ent.is_active;
    }
  }

  static fromObject(ent: IUser): User {
    return new User(ent);
  }
}
